<template>
  <card class="custom-shadow-card-header">
    <div slot="header">
      <h5 class="title">
        Perfil de Usuario
      </h5>
    </div>
    <div>
      <form>
        <h5> 1. Información General. </h5><hr>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nombre de Usuario"
                      v-model="user.username"
                      disabled>
            </fg-input>
          </div>
          <div class="col-md-6">
            <label>&nbsp;</label><br>
            <button type="button" class="btn btn-secondary btn-fill btn-md" @click.prevent="openModal"> 
                Cambiar Contraseña
            </button>            
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nombres"
                      v-model="user.first_name">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Apellidos"
                      v-model="user.last_name">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Correo Electronico"
                      v-model="user.email"
                      disabled>
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <fg-input 
            label="Descripción">
              <textarea v-model="user.description" class="form-control" rows="3">
              </textarea>
            </fg-input>
          </div>
        </div>      
        <h5> 2. Información de Perfil. </h5><hr>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Perfil"
                      v-model="user.roles[0].name"
                      disabled>
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Departamento"
                      v-model="user.department_label"
                      disabled>
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>Permisos</label><br>
            <template v-for="(permission, index) in user.permissions">
              <el-tag :key="permission.id"
                size="small"
                type="danger"
                :closable="false"
                :close-transition="false">
                  {{permission.name}}               
              </el-tag>       
              <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
            </template>                  
          </div>
        </div><hr>        
        <div class="text-center">
          <button type="submit" class="btn btn-danger btn-fill btn-wd" @click.prevent="updateProfile">
            Actualizar mi perfil
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
    <div class="row">
      <div class="col-12">
        <el-dialog class="custom-dialog"
          title="Cambiar Contraseña"
          :visible.sync="modals.change_password">
          <div class="text-center">
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input 
                    placeholder="Contraseña actual *"
                    v-model="user_password.old_password"
                    v-validate="modelValidations.old_password"
                    name="contraseña actual"
                    :error="getError('contraseña actual')"
                    :type="showPass.inputTypePass"
                    :myCustom="{addon : 'not-input-group-addon'}">
                    <template slot="addonRight">
                      <l-button @click="showPassword(1)"> <i :class="showPass.iconBtnPass"></i> </l-button>
                    </template>
                  </fg-input>            
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <fg-input 
                    placeholder="Contraseña Nueva *"
                    v-model="user_password.new_password"
                    v-validate="modelValidations.new_password"
                    ref="new_password"
                    name="contraseña nueva"
                    :error="getError('contraseña nueva')"
                    :type="showPass.inputTypePass2"
                    :myCustom="{addon : 'not-input-group-addon'}">
                    <template slot="addonRight">
                      <l-button @click="showPassword(2)"> <i :class="showPass.iconBtnPass2"></i> </l-button>
                    </template>
                  </fg-input>            
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <fg-input 
                    placeholder="Confirmación Contraseña Nueva *"
                    v-model="user_password.new_password_confirmation"
                    v-validate="modelValidations.new_password_confirmation"
                    name="confirmación de contraseña nueva"
                    :error="getError('confirmación de contraseña nueva')"
                    :type="showPass.inputTypePass2"
                    :myCustom="{addon : 'not-input-group-addon'}">
                    <template slot="addonRight">
                      <l-button @click="showPassword(2)"> <i :class="showPass.iconBtnPass2"></i> </l-button>
                    </template>
                  </fg-input>            
                </div>
              </div>
              <div class="row" v-if="errorAlert ">
                <div class="col-lg-12"><br>
                  <el-alert
                    :title="errorAlertTitle"
                    type="error"
                    :description="errorAlert"
                    show-icon>         
                  </el-alert>
                </div>        
              </div>        
            </form>          
          </div>
          <span slot="footer" class="dialog-footer custom-dialog-footer">
            <button class="btn btn-danger" @click="closeModal">Cancelar</button>&nbsp;
            <button class="btn btn-success" @click="validateSubmit">Confirmar</button>
          </span>
        </el-dialog>    
      </div>
    </div>
  </card>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Alert, Dialog, Tag } from 'element-ui'
  import showSwalAlert from 'src/util/alerts'
  import axios from 'axios'

  export default {
    components:{
        [Alert.name]: Alert,
        [Dialog.name]: Dialog,
        [Tag.name]: Tag,
    },    
    computed: {
      ...mapGetters({
        userdata: 'auth/user'
      })
    },
    data() {
      return {
        user: {
          first_name: null, 
          last_name: null,
          username: null,
          email: null,
          temporary_password: null,
          roles: null,
          role_id: null,
          departments: null,
          department_id: null,
          permissions: null,
          description: null,
        },
        user_password: {
          username: null,
          old_password: null,
          new_password: null,
          new_password_confirmation: null,
        },
        modals: {
          change_password: false
        },
        modelValidations: {
          old_password: {
            required: true,
            min:8
          },
          new_password: {
            required: true,
            min:8
          },
          new_password_confirmation: {
            required: true,
            confirmed:"new_password",
            min:8
          }
        },
        showPass: {
          inputTypePass: 'password',
          inputTypePass2: 'password',
          iconBtnPass: 'fa fa-eye',
          iconBtnPass2: 'fa fa-eye',  
        },        
        validateForm: false,
        errorAlert: null,
      }
    },
    methods: {
      openModal() {
        this.modals.change_password = true
      }, 
      closeModal() {
        this.modals.change_password = false
      },   
      getError (fieldName) {
          return this.errors.first(fieldName)
      },                
      showPassword(input_num) {
        if( input_num == '1'){
          if(this.showPass.inputTypePass === 'password') {
            this.showPass.iconBtnPass = 'fa fa-eye-slash'
            this.showPass.inputTypePass = 'text'
          } else {
            this.showPass.iconBtnPass = 'fa fa-eye'
            this.showPass.inputTypePass = 'password'
          }
        } else {
          if(this.showPass.inputTypePass2 === 'password') {
            this.showPass.iconBtnPass2 = 'fa fa-eye-slash'
            this.showPass.inputTypePass2 = 'text'
          } else {
            this.showPass.iconBtnPass2 = 'fa fa-eye'
            this.showPass.inputTypePass2 = 'password'
          }
        }
      },      
      validateSubmit () {
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            this.errorAlertTitle = 'Debe revisar los siguientes errores:'
            this.errorAlert = ``
            this.validateForm = true
            if( !(/[A-Z]/.test(this.user_password.new_password)) ){
              this.validateForm = false
              this.errorAlert += `La contraseña debe tener al menos una mayuscula.<br>`
            }
            if( !(/[a-z]/.test(this.user_password.new_password)) ){
              this.validateForm = false
              this.errorAlert += `La contraseña debe tener al menos una minuscula.<br>`
            }
            if( !(/[0-9]/.test(this.user_password.new_password)) ){
              this.validateForm = false
              this.errorAlert += `La contraseña debe tener al menos un numero.<br>`
            }
            if( !(/[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(this.user_password.new_password)) ){
              this.validateForm = false
              this.errorAlert += `La contraseña debe tener al menos un caracter especial.<br>`
            }
            if(this.validateForm) this.changePassword()
            this.errorAlert = this.errorAlert.replace(/<br\s*\\?>/g, '\n')
          } 
        })
      },       
      updateProfile () { 
        showSwalAlert('Actualizar perfil de usuario', 0, 'Confirmar', '¿Esta seguro que desea actualizar su perfil de usuario?')
          .then((result) => {
            if (result.value) {
              axios.post( '/auth/users/profile', this.user)
                .then((response) => {
                  this.$emit('showNotification', `<span> ${response.data.message} </span>`, 'success', 'nc-settings-tool-66')   
                })
                .catch((error) => {
                  this.$emit('showNotification', `<span> ${error.response.data.message} </span>`, 'danger', 'nc-simple-remove')   
                })                  
            }
          })              
      },
      changePassword(){
        this.user_password.username = this.user.username
        axios.post( '/auth/users/password', this.user_password)
          .then((response) => {
            this.closeModal()
            this.$emit('showNotification', `<span> Contraseña cambiada correctamente </span>`, 'success', 'nc-key-25')   
          })
          .catch((error) => {
            this.errorAlertTitle = 'Debe revisar los siguientes errores:'
            this.errorAlert = error.response.data.message
          })      
      },
    },
    created(){
      this.user.first_name = this.userdata.first_name
      this.user.last_name = this.userdata.last_name
      this.user.username = this.userdata.username
      this.user.email = this.userdata.email
      this.user.roles = this.userdata.roles
      this.user.description = this.userdata.description
      this.user.permissions = this.userdata.permissions
      if(this.user.roles[0].permissions) this.user.permissions = this.user.permissions.concat(this.user.roles[0].permissions)
      if(this.userdata.department) this.user.department_label = this.userdata.department.department
      else this.user.department_label = ''
    }
  }

</script>